import React from "react";
import ReactDom from "react-dom";

import {extendObservable, observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import c3 from "c3";
import numeral from "numeral";

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseViewStore from 'base-viewstore';
import BaseComponent from 'base-component';

export default class ResourcesViewStore extends BaseViewStore {

    @observable debriefVisible = false;
    @observable debriefLoading = false;
    @observable debriefRound = 1;
    @observable slide = 0;
    @observable totalSlides = 27;

    constructor(props) {
        super(props);
    }

    @action.bound hideDebrief() {
      this.debriefVisible = false;
    }
    @action.bound showDebrief(round) {
      this.debriefRound = round;
      this.slide = 0;
      this.debriefLoading = true;
      this.debriefVisible = true;

      let self = this;
      window.simgate.execQuery({
        query: "custom-queries://getDebriefTeams",
        parameters: { sessionId: window.application.dataModel.domainStore.context.team.parentId }	
      }).then(function (result) {
        let teams = [];
        let teamMap = {};
        for(let i = 0; i < result.data[0].length; ++i) {
          teams.push({
            name: result.data[0][i].Name,
            path: result.data[0][i].PathId,
            data: {},
          });
          teamMap[result.data[0][i].PathId] = teams[teams.length - 1];
        }
        window.simgate.execQuery({
          query: "custom-queries://getDebriefData",
          parameters: { 
            team1: teams[0] ? teams[0].path : -1,
            team2: teams[1] ? teams[1].path : -1, 
            team3: teams[2] ? teams[2].path : -1, 
            team4: teams[3] ? teams[3].path : -1, 
            team5: teams[4] ? teams[4].path : -1, 
            team6: teams[5] ? teams[5].path : -1,
          }	
        }).then(function (result) {
          for(let i = 0; i < result.data[0].length; ++i) {
              const data = result.data[0][i];
              if(teamMap[data.PathID]) {
                teamMap[data.PathID].data[data.Variable] = [
                  data.V0,
                  data.V1,
                  data.V2,
                  data.V3,
                ]
              }
          }

          let data = [], data2 = [], data3 = [], data4 = [], data5 = [];
          let labels = [];
          let round = self.debriefRound;
          self.totalSlides = [0,10,5,4][round];


            // graph 1
            data = ["Political Influence"];
            data2 = ["Bid Price"];
            data3 = ["HSE Index"];
            labels = [];
            for(var i = 0; i < teams.length; ++i) {
                var value = teams[i].data["BiddingDriverScoreR1P2S1"] ? teams[i].data["BiddingDriverScoreR1P2S1"][round] : 0;
                data.push(value);
                value = teams[i].data["BiddingDriverScoreR1P2S2"] ? teams[i].data["BiddingDriverScoreR1P2S2"][round] : 0;
                data2.push(value);
                value = teams[i].data["BiddingDriverScoreR1P2S3"] ? teams[i].data["BiddingDriverScoreR1P2S3"][round] : 0;
                data3.push(value);

                labels.push(teams[i].name);
            }
            c3.generate({
                bindto: "#graph-1-2",
                data: {
                    columns: [
                        data,
                        data2,
                        data3,
                    ],
                    type: 'bar'
                },
                axis: { 
                    x: { type: 'category', categories: labels },
                    y: { show: false }
                },
                tooltip: {
                  format: {
                    value: function (value, ratio, id, index) {
                      if(id == "Political Influence") {
                        var value = teams[index].data["FI_RES_PoliticalInfluenceRatingR1"] ? parseFloat(teams[index].data["FI_RES_PoliticalInfluenceRatingR1"][round]) : 0;
                        return numeral(value).format("0,0");
                      }
                      else if(id == "Bid Price") {
                        var value = teams[index].data["FI_DEC_LeaseBid_R1P2"] ? teams[index].data["FI_DEC_LeaseBid_R1P2"][round] : 0;
                        return numeral(value).format("$0,0");
                      }
                      else if(id == "HSE Index") {
                          var value = teams[index].data["Stored_HSEC_Index"] ? teams[index].data["Stored_HSEC_Index"][round] : 0;
                        return numeral(value).format("0,0");
                      }
                    }
                  }
                }
            });
            
            data = ["Lease Won"];
            labels = [];
            var winner1 = -1;
            var winner2 = -1;
            for(var i = 0; i < teams.length; ++i) {
                var value = teams[i].data["FI_RES_BidStatusR1P2"] ? teams[i].data["FI_RES_BidStatusR1P2"][round] : 0;
                var value2 = teams[i].data["BiddingDriverScoreR1P2"] ? teams[i].data["BiddingDriverScoreR1P2"][round] : 0;
                if (value == 2) {
                    if (winner1 >= 0) {
                        winner2 = i;
                    }
                    else {
                        winner1 = i;
                    }
                }
                data.push(value2);
                labels.push(teams[i].name);
            }
            c3.generate({
                bindto: "#graph-1",
                data: {
                    columns: [
                        data,
                    ],
                    type: 'bar'
                },
                axis: { 
                  x: { type: 'category', categories: labels },
                  y: { min: 0, padding: { bottom: 0 }, show: false },
                },
                legend: { show: false, },
                tooltip: { show: false, },
                onrendered: function() {
                    if(winner1 >= 0) {
                      $('#graph-1 .c3-chart-bar .c3-shapes-Lease-Won path:nth-child(' + (winner1 + 1) + ')').css({stroke: "rgb(44, 160, 44)", fill: "rgb(44, 160, 44)"});
                    }
                    if (winner2 >= 0) {
                        $('#graph-1 .c3-chart-bar .c3-shapes-Lease-Won path:nth-child(' + (winner2 + 1) + ')').css({ stroke: "rgb(44, 160, 44)", fill: "rgb(44, 160, 44)" });
                    }
                }
            });

            // graph 5
            data = ["Attempted Exploration"];
            data2 = ["Successful Exploration"];
            labels = [];
            for(var i = 0; i < teams.length; ++i) {
                var value = teams[i].data["FI_DEC_BlocksToExploreR1P2"] ? teams[i].data["FI_DEC_BlocksToExploreR1P2"][round] : 0;
                value *= teams[i].data["FI_WellsDrilledPerBlockR1P2"] ? teams[i].data["FI_WellsDrilledPerBlockR1P2"][round] : 0;
                data.push(value);
                value = Math.round(teams[i].data["FI_RES_NumberOfDiscoveriesR1P2"] ? teams[i].data["FI_RES_NumberOfDiscoveriesR1P2"][round] : 0);
                data2.push(value);
                labels.push(teams[i].name);
            }
            c3.generate({
                bindto: "#graph-5",
                data: {
                    columns: [
                        data,
                        data2,
                    ],
                    type: 'bar'
                },
                axis: { x: { type: 'category', categories: labels } },
            });

            // graph 9
            data = ["Global North - Conventional Gas"];
            data2 = ["Global South - Unconventional Gas"];
            labels = [];
            for(var i = 0; i < teams.length; ++i) {
                var value = teams[i].data["FI_RES_DevReservesR1P2"] ? teams[i].data["FI_RES_DevReservesR1P2"][round] : 0;
                data.push(value);
                value = teams[i].data["FI_RES_DevReservesR2P2"] ? teams[i].data["FI_RES_DevReservesR2P2"][round] : 0;
                data2.push(value);
                labels.push(teams[i].name);
            }
            c3.generate({
                bindto: "#graph-9",
                data: {
                    columns: [
                        data,
                        data2,
                    ],
                    type: 'bar'
                },
                axis: { 
                    x: { type: 'category', categories: labels },
                    y: { tick: { format:  function(v) { return numeral(v).format("0,0"); } } }
                },
            });


            // graph 11
            data = ["Global North - Conventional Gas"];
            data2 = ["Global South - Unconventional Gas"];
            labels = [];
            for(var i = 0; i < teams.length; ++i) {
                var value = teams[i].data["FI_RES_ProductionBOEPerDayR1P2"] ? teams[i].data["FI_RES_ProductionBOEPerDayR1P2"][round] : 0;
                data.push(value);
                value = teams[i].data["FI_RES_ProductionBOEPerDayR2P2"] ? teams[i].data["FI_RES_ProductionBOEPerDayR2P2"][round] : 0;
                data2.push(value);
                labels.push(teams[i].name);
            }
            c3.generate({
                bindto: "#graph-11",
                data: {
                    columns: [
                        data,
                        data2,
                    ],
                    type: 'bar'
                },
                axis: { 
                    x: { type: 'category', categories: labels },
                    y: { tick: { format:  function(v) { return numeral(v).format("0,0"); } } }
                },
            });
            
            // graph 12
            data = ["Brand Index"];
            data2 = ["Price Premium/Discount"];
            data3 = ["Political Influence"];
            data4 = ["HSE Index"];
            data5 = ["Number of Outlets"];
            labels = [];
            for(var i = 0; i < teams.length; ++i) {
                var value = teams[i].data["MarketDriverScoreR1S1"] ? teams[i].data["MarketDriverScoreR1S1"][round] : 0;
                data.push(value);
                value = teams[i].data["MarketDriverScoreR1S2"] ? teams[i].data["MarketDriverScoreR1S2"][round] : 0;
                data2.push(value);
                value = teams[i].data["MarketDriverScoreR1S3"] ? teams[i].data["MarketDriverScoreR1S3"][round] : 0;
                data3.push(value);
                value = teams[i].data["MarketDriverScoreR1S4"] ? teams[i].data["MarketDriverScoreR1S4"][round] : 0;
                data4.push(value);
                value = teams[i].data["MarketDriverScoreR1S5"] ? teams[i].data["MarketDriverScoreR1S5"][round] : 0;
                data5.push(value);

                labels.push(teams[i].name);
            }
            c3.generate({
                bindto: "#graph-12-2",
                data: {
                    columns: [
                        data,
                        data2,
                        data3,
                        data4,
                        data5,
                    ],
                    type: 'bar'
                },
                axis: { 
                    x: { type: 'category', categories: labels },
                    y: { show: false }
                },
                tooltip: {
                  format: {
                    value: function (value, ratio, id, index) {
                      if(id == "Brand Index") {
                        var value = teams[index].data["FI_RES_EndingBrandIndex"] ? parseFloat(teams[index].data["FI_RES_EndingBrandIndex"][round]) : 0;
                        return numeral(value).format("0,0");
                      }
                      else if(id == "Price Premium/Discount") {
                        var value = teams[index].data["FI_RES_PricePremDiscountR1"] ? teams[index].data["FI_RES_PricePremDiscountR1"][round] : 0;
                        return numeral(parseFloat(value) / 100).format("+0,0%");
                      }
                      else if(id == "Political Influence") {
                        var value = teams[index].data["FI_RES_PoliticalInfluenceRatingR1"] ? teams[index].data["FI_RES_PoliticalInfluenceRatingR1"][round] : 0;
                        return numeral(value).format("0,0");
                      }
                      else if(id == "HSE Index") {
                        var value = teams[index].data["FI_HSEC_Index"] ? teams[index].data["FI_HSEC_Index"][round] : 0;
                        return numeral(value).format("0,0");
                      }
                      else if(id == "Number of Outlets") {
                        var value = teams[index].data["FI_RES_TotalOutletsR1"] ? teams[index].data["FI_RES_TotalOutletsR1"][round] : 0;
                        return numeral(value).format("0,0");
                      }
                    }
                  }
                }
            });
            data = [];
            labels = [];
            var total = 0;
            for(var i = 0; i < teams.length; ++i) {
                var value = teams[i].data["FI_RES_MktShareR1"] ? teams[i].data["FI_RES_MktShareR1"][round] : 0;
                total += parseFloat(value);
                data.push([teams[i].name, value]);
            }
            data.push(["Rest of World", (1 - total)]);
            c3.generate({
                bindto: "#graph-12",
                data: {
                    columns: data,
                    type: 'pie'
                },
            });
            
            // graph 13
            data = ["Brand Index"];
            data2 = ["Price Premium/Discount"];
            data3 = ["Political Influence"];
            data4 = ["HSE Index"];
            data5 = ["Number of Outlets"];
            labels = [];
            for(var i = 0; i < teams.length; ++i) {
                var value = teams[i].data["MarketDriverScoreR2S1"] ? teams[i].data["MarketDriverScoreR2S1"][round] : 0;
                data.push(value);
                value = teams[i].data["MarketDriverScoreR2S2"] ? teams[i].data["MarketDriverScoreR2S2"][round] : 0;
                data2.push(value);
                value = teams[i].data["MarketDriverScoreR2S3"] ? teams[i].data["MarketDriverScoreR2S3"][round] : 0;
                data3.push(value);
                value = teams[i].data["MarketDriverScoreR2S4"] ? teams[i].data["MarketDriverScoreR2S4"][round] : 0;
                data4.push(value);
                value = teams[i].data["MarketDriverScoreR2S5"] ? teams[i].data["MarketDriverScoreR2S5"][round] : 0;
                data5.push(value);

                labels.push(teams[i].name);
            }
            c3.generate({
                bindto: "#graph-13-2",
                data: {
                    columns: [
                        data,
                        data2,
                        data3,
                        data4,
                        data5,
                    ],
                    type: 'bar'
                },
                axis: { 
                    x: { type: 'category', categories: labels },
                    y: { show: false }
                },
                tooltip: {
                  format: {
                    value: function (value, ratio, id, index) {
                      if(id == "Brand Index") {
                        var value = teams[index].data["FI_RES_EndingBrandIndex"] ? parseFloat(teams[index].data["FI_RES_EndingBrandIndex"][round]) : 0;
                        return numeral(value).format("0,0");
                      }
                      else if(id == "Price Premium/Discount") {
                        var value = teams[index].data["FI_RES_PricePremDiscountR1"] ? teams[index].data["FI_RES_PricePremDiscountR1"][round] : 0;
                        return numeral(parseFloat(value) / 100).format("+0,0%");
                      }
                      else if(id == "Political Influence") {
                        var value = teams[index].data["FI_RES_PoliticalInfluenceRatingR2"] ? teams[index].data["FI_RES_PoliticalInfluenceRatingR2"][round] : 0;
                        return numeral(value).format("0,0");
                      }
                      else if(id == "HSE Index") {
                        var value = teams[index].data["FI_HSEC_Index"] ? teams[index].data["FI_HSEC_Index"][round] : 0;
                        return numeral(value).format("0,0");
                      }
                      else if(id == "Number of Outlets") {
                        var value = teams[index].data["FI_RES_TotalOutletsR2"] ? teams[index].data["FI_RES_TotalOutletsR2"][round] : 0;
                        return numeral(value).format("0,0");
                      }
                    }
                  }
                }
            });
            data = [];
            labels = [];
            total = 0;
            for(var i = 0; i < teams.length; ++i) {
                var value = teams[i].data["FI_RES_MktShareR2"] ? teams[i].data["FI_RES_MktShareR2"][round] : 0;
                total += parseFloat(value);
                data.push([teams[i].name, value]);
            }
            data.push(["Rest of World", (1 - total)]);
            c3.generate({
                bindto: "#graph-13",
                data: {
                    columns: data,
                    type: 'pie'
                },
            });


            
            // graph 30
            var columns = [];
            labels = ["Period 0", "Period 1", "Period 2", "Period 3"];
            for(var i = 0; i < teams.length; ++i) {
                var value = teams[i].data["FI_RES_ProductionBOEPerDayR1P1"] ? teams[i].data["FI_RES_ProductionBOEPerDayR1P1"][round] : 0;
                columns[i] = [
                  teams[i].name,
                  parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][0] : 0),
                  parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][1] : 0),
                  parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][2] : 0),
                  parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][3] : 0),
                ];
            }
            c3.generate({
                bindto: "#graph-30",
                data: {
                    columns: columns,
                    type: 'line'
                },
                axis: { 
                    x: { type: 'category', categories: labels },
                    y: { tick: { format:  function(v) { return numeral(v).format("0,0.0%"); } } }
                },
            });



            var rrrTable = {
              header: "<th style='border-bottom: 1px solid;padding: 10px;'>RRR</th>",
              "north-oil": "<td style='text-align: left;padding: 10px;'><b>Global North Oil</b></td>",
              "north-gas": "<td style='text-align: left;padding: 10px;'><b>Global North Gas</b></td>",
              "south-oil": "<td style='text-align: left;padding: 10px;'><b>Global South Oil</b></td>",
              "south-gas": "<td style='text-align: left;padding: 10px;'><b>Global South Gas</b></td>",
            };
            
            for(var i = 0; i < teams.length; ++i) {

                var rrr1 = parseFloat(teams[i].data["FI_RES_RRRR1P1"] ? teams[i].data["FI_RES_RRRR1P1"][round] : 0);
                var rrr2 = parseFloat(teams[i].data["FI_RES_RRRR1P2"] ? teams[i].data["FI_RES_RRRR1P2"][round] : 0);
                var rrr3 = parseFloat(teams[i].data["FI_RES_RRRR2P1"] ? teams[i].data["FI_RES_RRRR2P1"][round] : 0);
                var rrr4 = parseFloat(teams[i].data["FI_RES_RRRR2P2"] ? teams[i].data["FI_RES_RRRR2P2"][round] : 0);

                rrrTable["header"] += "<th style='border-bottom: 1px solid;padding: 10px;'>" + teams[i].name + "</th>"
                rrrTable["north-oil"] += "<td style='padding: 10px;'>" + numeral(rrr1).format("0.0") + "</td>";
                rrrTable["north-gas"] += "<td style='padding: 10px;'>" + numeral(rrr2).format("0.0") + "</td>";
                rrrTable["south-oil"] += "<td style='padding: 10px;'>" + numeral(rrr3).format("0.0") + "</td>";
                rrrTable["south-gas"] += "<td style='padding: 10px;'>" + numeral(rrr4).format("0.0") + "</td>";
            }
          
            for(var j in rrrTable) {
                document.getElementById("rrr-" + j).innerHTML = rrrTable[j];
            }
            
            var roceTable = {
              header: "<th style='border-bottom: 1px solid;padding: 10px;'>ROCE</th>",
              "earnings": "<td style='text-align: left;padding: 10px;'><b>Earnings</b></td>",
              "capital": "<td style='text-align: left;padding: 10px;'><b>Capital Employed</b></td>",
              "roce": "<td style='text-align: left;padding: 10px;'><b>ROCE</b></td>",
            };
            
            for(var i = 0; i < teams.length; ++i) {

                var roce1 = parseFloat(teams[i].data["FI_RES_IncomeFromOps"] ? teams[i].data["FI_RES_IncomeFromOps"][round] : 0);
                var roce2 = parseFloat(teams[i].data["FI_TotAssets"] ? teams[i].data["FI_TotAssets"][round] : 0);
                var roce3 = parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][round] : 0);

                roceTable["header"] += "<th style='border-bottom: 1px solid;padding: 10px;'>" + teams[i].name + "</th>"
                roceTable["earnings"] += "<td style='padding: 10px;'>" + numeral(roce1).format("$0,0") + "</td>";
                roceTable["capital"] += "<td style='padding: 10px;'>" + numeral(roce2).format("$0,0") + "</td>";
                roceTable["roce"] += "<td style='padding: 10px;'>" + numeral(roce3).format("0.0%") + "</td>";
            }
          
            for(var j in roceTable) {
                document.getElementById("roce-" + j).innerHTML = roceTable[j];
            }


            var table = {
                "header": "<th style='border-bottom: 1px solid;'>&nbsp;</th>",
                "rrr": "<td style='text-align: left'><b>RRR</b></td>",
                "rrr-points": "<td style='text-align: left'>Weighted Points</td>",
                "market": "<td style='text-align: left'><b>Market Share</b></td>",
                "market-points": "<td style='text-align: left'>Weighted Points</td>",
                "roce": "<td style='text-align: left'><b>ROCE</b></td>",
                "roce-points": "<td style='text-align: left'>Weighted Points</td>",
                "totals": "<td style='text-align: left; border-top: 1px solid;'><b>Sub Total</b></td>",
                "combined": "<td style='text-align: left;'><b>TOTAL POINTS</b></td>",
            };
            
            for(var i = 0; i < teams.length; ++i) {
              teams[i].combinedScore = 0;
            }

            for(var r = 1; r <= round; ++r) {
              var rrr = [];
              var market = [];
              var roce = [];
              for(var i = 0; i < teams.length; ++i) {
                  var rr = parseFloat(teams[i].data["FI_RES_AvgRRR"] ? teams[i].data["FI_RES_AvgRRR"][r] : 0);
                  var m = (parseFloat(teams[i].data["FI_RES_MktShareR2"] ? teams[i].data["FI_RES_MktShareR2"][r] : 0) + parseFloat(teams[i].data["FI_RES_MktShareR1"] ? teams[i].data["FI_RES_MktShareR1"][r] : 0)) / 2;
                  var ro = parseFloat(teams[i].data["FI_ROCE"] ? teams[i].data["FI_ROCE"][r] : 0);
                  if(r == round) {
                    table["header"] += "<th style='border-bottom: 1px solid;'>" + teams[i].name + "</th>";
                    table["rrr"] += "<td>" + numeral(rr).format("0.00") + "</td>";
                    table["market"] += "<td>" + numeral(m).format("0.00%") + "</td>";
                    table["roce"] += "<td>" + numeral(ro).format("0.00%") + "</td>";
                  }
                  teams[i].temp = {
                      r: rr,
                      m: m,
                      ro: ro,
                  }
                  teams[i].scores = {
                      r: 0,
                      m: 0,
                      ro: 0,
                  }
                  rrr.push(teams[i]);
                  market.push(teams[i]);
                  roce.push(teams[i]);
              }

              rrr.sort(function(a, b) {
                  return Math.abs(1 - a.temp.r) - Math.abs(1 - b.temp.r);
              })
              market.sort(function(a, b) {
                  return b.temp.m - a.temp.m;
              })
              roce.sort(function(a, b) {
                  return b.temp.ro - a.temp.ro;
              })
              var points = [10, 8, 6, 4, 2, 1, 0, 0, 0];
              for(var i = 0; i < rrr.length; ++i) {
                  if(rrr[i].temp.r == 0) { continue; }
                  rrr[i].scores.r = points[i] * 0.3;
              }
              for(var i = 0; i < market.length; ++i) {
                  if(market[i].temp.m == 0) { continue; }
                  market[i].scores.m = points[i] * 0.3;
              }
              for(var i = 0; i < roce.length; ++i) {
                  if(roce[i].temp.ro == 0) { continue; }
                  roce[i].scores.ro = points[i] * 0.4;
              }
              for(var i = 0; i < teams.length; ++i) {
                teams[i].combinedScore += teams[i].scores.r + teams[i].scores.m + teams[i].scores.ro;
              }
              if(r == round) {
                for(var i = 0; i < teams.length; ++i) {
                    table["rrr-points"] += "<td>" + numeral(teams[i].scores.r).format("0.0") + "</td>";
                    table["market-points"] += "<td>" + numeral(teams[i].scores.m).format("0.0") + "</td>";
                    table["roce-points"] += "<td>" + numeral(teams[i].scores.ro).format("0.0") + "</td>";
                    table["totals"] += "<td style='border-top: 1px solid;'><b>" + numeral(teams[i].scores.r + teams[i].scores.m + teams[i].scores.ro).format("0.0") + "</b></td>";
                    table["combined"] += "<td style='border-top: 1px solid;'><b>" + numeral(teams[i].combinedScore).format("0.0") + "</b></td>";
                }
              }
            }
            
            for(var j in table) {
                document.getElementById("scores-" + j).innerHTML = table[j];
            }

        }, function(error) {
          console.log(error);
        }).always(function () {
          self.debriefLoading = false;
        });
      }, function(error) {
        alert(error);
        self.debriefLoading = false;
      }).always(function () {
      });

    }
    @action.bound nextSlide() {
        ++this.slide;
        if(this.slide > this.totalSlides) {
          this.slide = this.totalSlides;
        }
    }
    
    @action.bound prevSlide() {
        --this.slide;
        if(this.slide < 0) {
           this.slide = 0;
        }
    }
}


// WEBPACK FOOTER //
// ./app_modules/resources-activity/src/viewstore.js